import { inject } from '@angular/core'
import type { CanActivateFn } from '@angular/router'
import { Router } from '@angular/router'
import { AuthService } from './auth.service'
import type { Role } from './types'

export function roleGuard(first: Role, ...rest: Role[]): CanActivateFn {
  const required: Role[] = [first, ...rest]
  return async (_route, state) => {
    const auth = inject(AuthService)
    const router = inject(Router)
    // Rehydrate on a cold load (direct URL / refresh): the in-memory signal is
    // empty and Angular runs the guards in a canActivate array concurrently, so
    // we cannot assume authGuard populated it first. fetchMe() dedupes the
    // in-flight request, so the two guards still trigger a single /me call.
    const user = auth.currentUser() ?? (await auth.fetchMe())
    if (!user) {
      // FR-051 U7 (AC-5.6): the login of the brand shown (the host's on an agency host);
      // FR-052 V9-1 (AC-7.2): there, with the requested page as returnUrl.
      void router.navigateByUrl(auth.loginUrlFor(state?.url))
      return false
    }
    if ((user.memberships?.length ?? 0) === 0) {
      void router.navigateByUrl('/no-access') // M7 orphan terminal state
      return false
    }
    if (user.role === null) {
      void router.navigateByUrl('/select-account') // >1 membership, none selected
      return false
    }
    if (!required.includes(user.role)) {
      void router.navigateByUrl('/403')
      return false
    }
    return true
  }
}
